function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import CareersComponent from "components/pages/careers/careers-component";
import ErrorCareersComponent from "components/pages/careers/error-careers-component/error-careers-component";
import { getDataFromComeet } from "server/services/comeet-service/comeet-service";
import { CAREERS_ERROR_RENDERED } from "constants/bigbrain-event-types";
import { CAREERS_PAGE } from "constants/careers/careers";
import { filterByPositionType } from "components/pages/careers/careers-service";
import BaseTemplatePage, { getSerializedServerProps, getServerSideProps as getBaseProps } from "../../generated-templates/base-template-page";
import { InternalServerError } from "server/extensions/error-extensions";
import { INTERNAL_SERVER_ERROR_CODE } from "constants/status-codes";
import { getGeneratorSystemConfigOnRequest } from "server/services/request-service/request-service";
import { handleServerException } from "server/services/exceptions-handling-service/exceptions-handling-service";
export function getServerSideProps(context) {
    return _getServerSideProps.apply(this, arguments);
}
function _getServerSideProps() {
    _getServerSideProps = _async_to_generator(function*(context) {
        const baseInitialProps = yield getBaseProps(context);
        const serverProps = baseInitialProps.props;
        const { handleServerException } = require("../../../server/services/exceptions-handling-service/exceptions-handling-service");
        const { translations, isMobileOrTabletBrowser, cloudfrontViewerCountry } = serverProps;
        const { positionsType } = context.query;
        try {
            var _getGeneratorSystemConfigOnRequest;
            const allPositionsData = yield getDataFromComeet();
            if (!allPositionsData || allPositionsData.ERROR) {
                throw new InternalServerError("error fetching positions data");
            }
            const positionsData = filterByPositionType(allPositionsData, positionsType);
            const props = {
                positionsData,
                translations,
                asPath: context.req.url,
                isTypeformDisabled: (_getGeneratorSystemConfigOnRequest = getGeneratorSystemConfigOnRequest(context.req)) === null || _getGeneratorSystemConfigOnRequest === void 0 ? void 0 : _getGeneratorSystemConfigOnRequest.isTypeformDisabled,
                positionsType,
                isMobileOrTabletBrowser,
                cloudfrontViewerCountry
            };
            return {
                props: getSerializedServerProps(props)
            };
        } catch (e) {
            yield handleServerException({
                e,
                req: context.req,
                res: context.res,
                bbEventParams: {
                    name: CAREERS_ERROR_RENDERED,
                    kind: CAREERS_PAGE
                }
            });
            context.res.statusCode = INTERNAL_SERVER_ERROR_CODE;
            return {
                props: {
                    translations
                }
            };
        }
    });
    return _getServerSideProps.apply(this, arguments);
}
class CareersPage extends BaseTemplatePage {
    render() {
        const { positionsData, translations } = this.props;
        if (!positionsData) return /*#__PURE__*/ _jsx(ErrorCareersComponent, {
            translations: translations
        });
        return /*#__PURE__*/ _jsx(CareersComponent, _object_spread({}, this.props));
    }
}
export { CareersPage as default };
